import {
    Box,
    FormControl,
    FormHelperText,
    OutlinedInput,
    Typography,
} from '@mui/material'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

interface TextInputProps {
    id: string
    label: string
    value: string
    onChange: any
    type?: string
    required?: boolean
    onblur?: any
    onEnter?: any
    placeholder?: string
    disabled?: boolean
    errorMessage?: string
    endAdornment?: any
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>((props, ref) => {
    const {
        id,
        label,
        value,
        onChange,
        type = 'text',
        required,
        onblur = () => undefined,
        onEnter = () => undefined,
        placeholder,
        disabled,
        errorMessage = '',
        endAdornment,
    } = props
    const { t } = useTranslation()
    return (
        <Box sx={{ width: '100%' }}>
            <FormControl fullWidth>
                <Typography sx={{ opacity: '0.7', fontSize: '14px' }}>
                    {label}
                    {required ? '*' : ''}
                </Typography>
                <OutlinedInput
                    size="small"
                    id={id}
                    label=""
                    value={value}
                    inputRef={ref}
                    onChange={(e) => onChange(id, e.target.value)}
                    onBlur={(e) => onblur(id, e.target.value)}
                    sx={{
                        width: '100%',
                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
                            {
                                display: 'none',
                            },
                        '& input[type=number]': {
                            MozAppearance: 'textfield',
                        },
                        '& ::placeholder': {
                            // opacity: 0.14,
                        },
                    }}
                    placeholder={
                        placeholder ? placeholder : t('enterLabel', { label })
                    }
                    aria-label={label}
                    inputProps={{
                        style: {
                            fontSize: 14,
                            opacity:
                                value !== '' && value !== null ? '1' : '0.4',
                        },
                        type: `${type}`,
                        onKeyPress: (e) => {
                            if (e.key === 'Enter') {
                                onEnter(
                                    id,
                                    (e.target as HTMLInputElement).value,
                                )

                                // write your functionality here
                                e.preventDefault()
                            }
                        },
                    }}
                    disabled={!!disabled}
                    error={errorMessage !== ''}
                    endAdornment={
                        endAdornment ? (
                            <Typography
                                sx={{
                                    opacity: disabled ? '0.5' : '0.7',
                                    fontSize: '14px',
                                }}
                            >
                                {endAdornment}
                            </Typography>
                        ) : (
                            ''
                        )
                    }
                />
                {errorMessage !== '' && (
                    <FormHelperText sx={{ color: 'red' }}>
                        {errorMessage}
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    )
})
TextInput.displayName = 'TextInput'
export default TextInput
